const locale = {
	// #region Page layout
	NEW: 'New',
	COPY: ' - (COPY)',
	// MODULE: 'Module: ',

	LOADING: 'Loading...',
	LIST_NO_ITEMS: 'No results found',

	FULLSCREEN_BUTTON: 'Fullscreen mode',

	RECENT_ACTIVITY_TITLE: 'Last actions',
	MY_NOTES_TITLE: 'My notes',

	NOTIFICATIONS_TITLE: 'Notifications',
	NOTIFICATIONS_DISMISS_ALL: 'dismiss all',
	NOTIFICATIONS_NONE: 'You have no notifications to read',
	NOTIFICATIONS_BUTTON: 'Notifications',

	USER_MENU_PROFILE: 'My Profile',
	USER_MENU_LOGOUT: 'Logout',

	BREADCRUMBS_DASHBOARD: 'Dashboard',
	BREADCRUMBS_DETAILS: 'Details',
	BREADCRUMBS_EDIT: 'Edit',
	BREADCRUMBS_ADD: 'New',

	// #region Calendario
	CALENDAR_TOOLTIP_TODAY: 'Today',
	CALENDAR_TOOLTIP_DAY: 'Day',
	CALENDAR_TOOLTIP_WEEK: 'Week',
	CALENDAR_TOOLTIP_MONTH: 'Month',
	CALENDAR_TOOLTIP_PREVIOUS: 'Previous',
	CALENDAR_TOOLTIP_NEXT: 'Next',
	// #endregion

	SEARCH_PLACEHOLDER: 'Search...',
	SEARCH_BUTTON: 'Search',
	FILTER_BUTTON: 'Filter',
	FILTER_QUERY_BUILDER_BUTTON: 'Advanced filter',
	FILTER_CLEAR_BUTTON: 'Remove filters',
	IMPORT_BUTTON: 'Import',
	IMPORT_FILE: 'Import from file',
	OPEN_IN_NEW_BUTTON: 'Open in new tab',

	ORDER_DEFAULT: 'Default order',
	ORDER_ASCENDING: 'ascending',
	ORDER_DESCENDING: 'descending',

	PAGINATOR_ROWS_DISPLAYED: '{from}–{to} of {total}',
	PAGINATOR_ROWS_COUNT: '{value} rows',

	QUERY_BUILDER_PREVIEW: 'Query SQL Preview',

	LANGUAGE_FIELD: 'Language',
	LAYOUT_FIELD: 'Layout',
	THEME_FIELD: 'Theme',
	THEME_HEADER: 'Header',
	THEME_PAPER: 'Paper',
	THEME_BACKGROUND: 'Background',

	MODULESEARCH_RESULTS_COUNT: '{n} of {tot} results',

	ADDRESS2: '{zip} {city} {district} {country}',
	VALUE: 'Value: {value}',
	DURATION: 'Duration: {duration}',
	DURATION_EXPECTED: 'Expected duration: {duration}',
	DURATION_HOURS: '{value} h',
	// STATUSES: 'Statuses',
	// TYPES: 'Types',
	// OTHER: 'Other',
	DEFAULT_VALUE: 'Default',
	DEFAULT_ITEM: 'Default',
	UNSUBSCRIBED: 'Unsubscribed',

	ACTION_EDIT: 'Edit',
	DELETED_VALUE: 'Deleted',
	// #endregion

	// #region Module names
	MODULE_COMPANIES_NAME: 'Companies',
	MODULE_COMPANIES_NAME_SINGULAR: 'Company',
	MODULE_COMPANIES_RELATIONS_NAME: 'Companies Relation Types',
	MODULE_COMPANIES_TYPES_NAME: 'Companies Types',
	MODULE_COMPANIES_SUBTYPES_NAME: 'Companies Subtypes',
	MODULE_COMPANIES_STATUSES_NAME: 'Companies Statuses',
	MODULE_PEOPLE_NAME: 'People',
	MODULE_PEOPLE_NAME_SINGULAR: 'Person',
	MODULE_PEOPLE_STATUSES_NAME: 'People Statuses',
	MODULE_PEOPLE_TYPES_NAME: 'People Types',
	MODULE_ITEMS_NAME: 'Items',
	MODULE_ITEMS_NAME_SINGULAR: 'Item',
	MODULE_ITEMS_TYPES_NAME: 'Item Types',
	MODULE_ITEMS_UNITSOFMEASURE_NAME: 'Item Units of measure',
	MODULE_ITEMS_SERIES_NAME: 'Item Series',
	MODULE_ITEMS_MEASURES_NAME: 'Item Measures',
	MODULE_CHRONOLOGY_NAME: 'Event',
	MODULE_CHRONOLOGY_NAME_SINGULAR: 'Event',
	MODULE_CHRONOLOGY_STATUSES_NAME: 'Event Statuses',
	MODULE_CHRONOLOGY_TYPES_NAME: 'Event Types',
	MODULE_MARKETINGACTIONS_NAME: 'Marketing Actions',
	MODULE_MARKETINGACTIONS_NAME_SINGULAR: 'Marketing Action',
	MODULE_MARKETINGACTIONS_STATUSES_NAME: 'Marketing Actions Statuses',
	MODULE_MARKETINGACTIONS_TYPES_NAME: 'Marketing Actions Types',
	MODULE_COMMERCIALCAMPAIGNS_NAME: 'Commercial Campaigns',
	MODULE_COMMERCIALCAMPAIGNS_NAME_SINGULAR: 'Commercial Campaign',
	MODULE_COMMERCIALCAMPAIGNS_STATUSES_NAME: 'Commercial Campaign Statuses',
	MODULE_COMMERCIALCAMPAIGNS_TYPES_NAME: 'Commercial Campaign Types',
	MODULE_OPPORTUNITIES_NAME: 'Opportunities',
	MODULE_OPPORTUNITIES_NAME_SINGULAR: 'Opportunity',
	MODULE_OPPORTUNITIES_STATUSES_NAME: 'Opportunities Statuses',
	MODULE_OPPORTUNITIES_TYPES_NAME: 'Opportunities Types',
	MODULE_ERP_QUOTATIONS_NAME: 'NAV Quotations',
	MODULE_ERP_QUOTATIONS_LINES_NAME: 'Quotations Lines',
	MODULE_ERP_ORDERS_NAME: 'NAV Orders',
	MODULE_ERP_ORDERS_LINES_NAME: 'Order Lines',
	MODULE_CONTRACTS_NAME: 'Contracts',
	MODULE_CONTRACTS_NAME_SINGULAR: 'Contract',
	MODULE_CONTRACTS_STATUSES_NAME: 'Contracts Statuses',
	MODULE_CONTRACTS_TYPES_NAME: 'Contracts Types',
	MODULE_CONTRACTS_LINES_NAME: 'Rows',
	MODULE_ORDERS_NAME: 'Orders',
	MODULE_ORDERS_NAME_SINGULAR: 'Order',
	MODULE_ORDERS_STATUSES_NAME: 'Orders Statuses',
	MODULE_ORDERS_TYPES_NAME: 'Orders Types',
	MODULE_ORDERS_LINES_NAME: 'Rows',
	MODULE_ORDERS_BILLING_NAME: 'Billing schedule',
	MODULE_PROJECTS_NAME: 'Projects',
	MODULE_PROJECTS_NAME_SINGULAR: 'Project',
	MODULE_PROJECTS_STATUSES_NAME: 'Projects Statuses',
	MODULE_PROJECTS_TYPES_NAME: 'Projects Types',
	MODULE_ACTIVITIES_NAME: 'Activities',
	MODULE_ACTIVITIES_NAME_SINGULAR: 'Activity',
	MODULE_ACTIVITIES_STATUSES_NAME: 'Activities Statuses',
	MODULE_ACTIVITIES_TYPES_NAME: 'Activities Types',
	MODULE_DEMS_NAME: 'DEMs',
	MODULE_DEMS_NAME_SINGULAR: 'DEM',
	MODULE_DEMS_STATUSES_NAME: 'DEMs Statuses',
	MODULE_TICKETS_NAME: 'Tickets',
	MODULE_TICKETS_NAME_SINGULAR: 'Ticket',
	MODULE_TICKETS_STATUSES_NAME: 'Tickets Statuses',
	MODULE_TICKETS_TYPES_NAME: 'Tickets Types',
	MODULE_WORKREPORTS_NAME: 'Work Reports',
	MODULE_WORKREPORTS_NAME_SINGULAR: 'Work Report',
	MODULE_WORKREPORTS_STATUSES_NAME: 'Work Reports Statuses',
	MODULE_WORKREPORTS_TYPES_NAME: 'Work Reports Types',
	MODULE_INVOICES_NAME: 'Invoices',
	MODULE_INVOICES_NAME_SINGULAR: 'Invoice',
	MODULE_INVOICES_STATUSES_NAME: 'Invoice Statuses',
	MODULE_INVOICES_TYPES_NAME: 'Invoice Types',
	MODULE_INVOICES_DEADLINES_NAME: 'Invoice Deadlines',
	MODULE_INVOICES_DEADLINES_SINGULAR_NAME: 'Invoice Deadlines',
	MODULE_INVOICES_DEADLINES_STATUSES_NAME: 'Invoice Deadlines Statuses',
	MODULE_TAGS_NAME: 'Tags',
	MODULE_MAILS_NAME: 'Mail Addresses',
	MODULE_MAILS_NAME_SINGULAR: 'Mail Address',
	MODULE_PHONES_NAME: 'Phone Numbers',
	MODULE_PHONES_NAME_SINGULAR: 'Phone Number',
	MODULE_PHONECALLS_NAME: 'Phone Calls',
	MODULE_PHONECALLS_NAME_SINGULAR: 'Phone Call',
	MODULE_SOCIALNETWORKS_NAME: 'Social Network',
	MODULE_SOCIALNETWORKS_NAME_SINGULAR: 'Social Networks',
	MODULE_SOCIALNETWORKS_TYPES_NAME: 'Social Networks Types',
	MODULE_WEBSITES_NAME: 'Websites',
	MODULE_WEBSITES_NAME_SINGULAR: 'Website',
	MODULE_USERS_NAME: 'Users',
	MODULE_USERS_NAME_SINGULAR: 'User',
	MODULE_GROUPS_NAME: 'Groups',
	MODULE_GROUPS_NAME_SINGULAR: 'Group',
	MODULE_NOTES_NAME: 'Notes',
	MODULE_NOTES_NAME_SINGULAR: 'Note',
	MODULE_DOCS_NAME: 'Documents',
	MODULE_DOCS_NAME_RESERVED: 'Reserved documents',
	// MODULE_FILTERS_NAME: 'Filters',
	MODULE_SYS_LOGS_TYPES_NAME: 'Logs Types',
	MODULE_WBS_NODES_NAME: 'WBS Nodes',
	MODULE_SYS_KPIS_NAME: 'KPIs',
	MODULE_SYS_KPIS_NAME_SINGULAR: 'KPI',
	MODULE_SYS_KPIS_GOALS_NAME: 'KPI Goals',
	MODULE_SYS_KPIS_GOALS_NAME_SINGULAR: 'KPI Goal',
	MODULE_SYS_KPIS_GOALS_STATUSES_NAME: 'KPI Goals Statuses',

	MODULE_SYSTEM_TABLES_NAME: 'System Tables',
	MODULE_MISC_NAME: 'Miscellaneous',
	MODULE_LANGUAGES_NAME: 'Languages',
	MODULE_DISTRICTS_NAME: 'Districts',
	MODULE_REGIONS_NAME: 'Regions',
	MODULE_COUNTRIES_NAME: 'Countries',
	MODULE_ZONES_NAME: 'Zones',
	MODULE_LEADCHANNELS_NAME: 'Lead Channel',
	MODULE_COMPANIES_ATECO_NAME: 'ATECO Codes',
	MODULE_COMPANIES_ATECOTYPE_NAME: 'ATECO Types',
	MODULE_COMPANIES_LEGALFORMS_NAME: 'Companies Legal Forms',
	MODULE_PRICINGGROUPS_NAME: 'Pricings groups',
	MODULE_DISCOUNTGROUPS_NAME: 'Discount groups',
	MODULE_PAYMENTMETHODS_NAME: 'Payment methods',
	MODULE_PAYMENTTERMS_NAME: 'Payment terms',
	MODULE_SHIPPINGAGENTS_NAME: 'Shipping agents',
	MODULE_SHIPPINGMETHODS_NAME: 'Shipping methods',
	// #endregion

	// #region Administration tools
	RECYCLE_BIN_PAGE: 'Recycle Bin',
	SETTINGS_PAGE: 'Settings',
	LOGS_PAGE: 'System Logs',
	PERMISSIONS_MANAGEMENT_PAGE: 'Permissions management',
	EXCHAGE_MAILS_LOGS_PAGE: 'Exchange mails logs',
	// #endregion

	// #region Details tabs
	TAB_SUMMARY: 'Summary',
	TAB_CONTACTS: 'Contacts',
	TAB_GROUPS_USERS: 'Users',
	TAB_RECIPIENTS: 'Recipients',
	TAB_LINKS: 'Clicked Links',
	TAB_WBS: 'WBS',
	// #endregion

	// #region Details Basic informations section
	DETAILS_INFO_SECTION: 'Basic informations',
	DETAILS_INFO_SUBHEADER: 'View and edit basic information',
	// #endregion

	// #region Details Secondary informations section
	DETAILS_SECONDARY_INFO_SECTION: 'Secondary informations',
	DETAILS_SECONDARY_INFO_SUBHEADER: 'View and edit secondary informations',
	// #endregion

	// #region Details Description section
	DETAILS_DESCRIPTION_SECTION: 'Description',
	DETAILS_DESCRIPTION_SUBHEADER: 'View and edit the description',
	// #endregion

	// #region Details Contacts section
	DETAILS_CONTACTS_MAILS_SECTION: 'Emails',
	DETAILS_CONTACTS_PHONES_SECTION: 'Phone Numbers',
	// #endregion

	// #region Details Source section
	DETAILS_SOURCE_SECTION: 'Source',
	DETAILS_SOURCE_SUBHEADER: 'View and edit this registry source',
	// #endregion

	// #region Details Flow section
	DETAILS_FLOW_SECTION: 'Flow',
	DETAILS_FLOW_SUBHEADER: "View and edit this entry's flow",
	DETAILS_FLOW_SECTION_BUTTON_ADD: 'Add node',

	DETAILS_FLOW_DIALOG_ADD_PARENT_TITLE: 'Add parent node',
	DETAILS_FLOW_FIELD_PARENT_TYPE: 'Module',

	DETAILS_FLOW_FIELD_MARKETINGACTION: 'Origin Marketing Action',
	DETAILS_FLOW_FIELD_COMMERCIALCAMPAIGN: 'Origin Commercial Campaign',
	DETAILS_FLOW_FIELD_DEM: 'Origin DEM',
	DETAILS_FLOW_FIELD_OPPORTUNITY: 'Origin Opportunity',
	DETAILS_FLOW_FIELD_CONTRACT: 'Origin Contract',
	DETAILS_FLOW_FIELD_ORDER: 'Origin Order',
	DETAILS_FLOW_FIELD_PROJECT: 'Origin Project',
	DETAILS_FLOW_FIELD_ACTIVITY: 'Origin Activity',
	DETAILS_FLOW_FIELD_TICKET: 'Origin Ticket',
	DETAILS_FLOW_FIELD_WORKREPORT: 'Origin Work Report',
	DETAILS_FLOW_FIELD_CHRONOLOGY: 'Origin Chronology',
	// #endregion

	// #region Details Pricing section
	DETAILS_PRICING_SECTION: 'Pricing',
	DETAILS_PRICING_SUBHEADER: 'View and edit pricing informations',
	// #endregion

	// #region Details SystemInfo section
	SYSTEMINFO_TITLE: 'System Info',
	SYSTEMINFO_CREATED: 'Created at {datetime} by {user}',
	SYSTEMINFO_MODIFIED: 'Last modified at {datetime} by {user}',
	SYSTEMINFO_DELETED: 'Deleted at {datetime} by {user}',
	SYSTEMINFO_LOG_ALERT_TITLE: 'Log Mode',
	SYSTEMINFO_LOG_ALERT_SUBTITLE: 'View the fields logs and restore the previous values',
	// #endregion

	// #region Details contacts
	DETAILS_PHONES_SUBHEADER: 'View the associated phone numbers',
	DETAILS_MAILS_SUBHEADER: 'View the associated mail addresses',
	DETAILS_SOCIALNETWORKS_SUBHEADER: 'View the associated social networks',
	DETAILS_WEBSITES_SUBHEADER: 'View the associated websites',
	// #endregion

	NO_FILE_UPLOADED: 'No file uploaded',

	// #region View items
	VIEW_TABLE_COLUMN_ACTIONS: 'Actions',

	VIEW_TABLE_BUTTON_COLUMN_VISIBILITY: 'Manage columns',
	VIEW_TABLE_BUTTON_COLUMN_VISIBILITY_SHOW_ALL: 'Show all',
	VIEW_TABLE_BUTTON_COLUMN_VISIBILITY_HIDE_ALL: 'Hide all',

	// VIEW_ITEM_NO_WEBSITE: 'No website',
	VIEW_ITEM_NO_MAIL: 'No Mail',
	VIEW_ITEM_NO_PHONE: 'No Phone',
	VIEW_ITEM_NO_COMPANY: 'No Company',
	VIEW_ITEM_NO_DESCRIPTION: 'No description',
	VIEW_ITEM_NO_DATE: 'No date',
	VIEW_ITEM_NO_DATES: 'No dates',
	VIEW_ITEM_NO_INTGROUP: 'No internal Group',
	VIEW_ITEM_NO_INTUSER: 'No internal User assigned',
	VIEW_ITEM_NO_EXTUSER: 'No external User assigned',
	VIEW_ITEM_NO_EXTREF: 'No external reference',
	VIEW_ITEM_NO_DEM: 'No linked DEM',
	VIEW_ITEM_NO_OFFICE: 'No office',
	// VIEW_ITEM_NO_LINK_TO_MAIL: 'No links to this e-mail',

	VIEW_ITEM_BUTTON_MORE: 'More',
	VIEW_ITEM_BUTTON_EDIT: 'Edit',
	VIEW_ITEM_BUTTON_OPEN_MAPS: 'Open in Google Maps',
	VIEW_ITEM_BUTTON_OPEN_ALLIANZ_TRADE: 'Open in Allianz Trade',
	// VIEW_ITEM_BUTTON_FAVOURITE: 'Favourite',
	VIEW_ITEM_BUTTON_DELETE: 'Delete',
	VIEW_ITEM_BUTTON_REMOVE: 'Remove',
	VIEW_ITEM_BUTTON_RESTORE_VALUE: 'Restore value',
	VIEW_ITEM_BUTTON_ADD_COPY: 'Create Copy',
	VIEW_ITEM_BUTTON_DETAILS: 'View Details',
	VIEW_ITEM_BUTTON_PERMANENT_DELETE: 'Permanently Delete',
	VIEW_ITEM_BUTTON_RESTORE: 'Restore',
	VIEW_ITEM_BUTTON_DOWNLOAD: 'Download',
	VIEW_ITEM_BUTTON_IMAGE_EDITOR: 'Edit Image',
	VIEW_ITEM_BUTTON_MOVE_UP: 'Move up',
	VIEW_ITEM_BUTTON_MOVE_DOWN: 'Move down',

	VIEW_ITEM_BUTTON_NEW_COMPANY: 'New Company',
	VIEW_ITEM_BUTTON_NEW_PERSON: 'New Person',
	VIEW_ITEM_BUTTON_NEW_MARKETINGACTION: 'New Marketing Action',
	VIEW_ITEM_BUTTON_NEW_COMMERCIALCAMPAIGNS: 'New Commercial Campaign',
	VIEW_ITEM_BUTTON_NEW_OPPORTUNITY: 'New Opportunity',
	VIEW_ITEM_BUTTON_NEW_CONTRACT: 'New Contract',
	VIEW_ITEM_BUTTON_NEW_ORDER: 'New Order',
	VIEW_ITEM_BUTTON_NEW_PROJECT: 'New Project',
	VIEW_ITEM_BUTTON_NEW_ACTIVITY: 'New Activity',
	VIEW_ITEM_BUTTON_NEW_TICKET: 'New Ticket',
	VIEW_ITEM_BUTTON_NEW_EVENT: 'New Event',
	VIEW_ITEM_BUTTON_NEW_WORKREPORT: 'New Work Report',
	VIEW_ITEM_BUTTON_NEW_DEM: 'New DEM',
	VIEW_ITEM_BUTTON_NEW_NOTE: 'New Note',
	VIEW_HEADER_BUTTON_NEW_USER: 'New User',
	VIEW_ITEM_BUTTON_NEW_INVOICE: 'New Invoice',
	// VIEW_ITEM_BUTTON_NEW_ITEM: 'New Item',

	VIEW_HEADER_BUTTON_REFRESH: 'Refresh',
	VIEW_HEADER_BUTTON_SELECT: 'Select',
	VIEW_HEADER_BUTTON_NEW: 'New',
	// VIEW_HEADER_BUTTON_PRINT: 'Print',
	VIEW_HEADER_BUTTON_EXPORT: 'Generate Report',
	VIEW_HEADER_BUTTON_DOWNLOAD_CSV: 'Download CSV',
	// #endregion

	// #region Details headers
	DETAILS_HEADER_BUTTON_EXPORT: 'Generate Report',
	DETAILS_HEADER_BUTTON_FAVOURITE: 'Favourite',
	DETAILS_HEADER_BUTTON_DELETE: 'Delete',
	// DETAILS_HEADER_BUTTON_EDIT: 'Edit',
	// DETAILS_HEADER_BUTTON_UNDO: 'Undo',
	DETAILS_HEADER_BUTTON_SHOW_LOG: 'Show Logs',

	DETAILS_HEADER_BUTTON_SHARE: 'Share',

	// DETAILS_HEADER_BUTTON_NEW_COMPANY: 'New Company',
	DETAILS_HEADER_BUTTON_NEW_CHILD: 'New Subsidiary',
	DETAILS_HEADER_BUTTON_NEW_LEAD_COMPANY: 'New Lead Company',
	DETAILS_HEADER_BUTTON_NEW_LEAD_PERSON: 'New Lead People',
	DETAILS_HEADER_BUTTON_NEW_PERSON: 'New Person',
	DETAILS_HEADER_BUTTON_NEW_EVENT: 'New Event',
	DETAILS_HEADER_BUTTON_NEW_MARKETINGACTION: 'New Marketing Action',
	DETAILS_HEADER_BUTTON_NEW_DEM: 'New DEM',
	DETAILS_HEADER_BUTTON_NEW_COMMERCIALCAMPAIGN: 'New Commercial Campaign',
	DETAILS_HEADER_BUTTON_NEW_OPPORTUNITY: 'New Opportunity',
	DETAILS_HEADER_BUTTON_NEW_CONTRACT: 'New Contract',
	DETAILS_HEADER_BUTTON_NEW_PROJECT: 'New Project',
	DETAILS_HEADER_BUTTON_NEW_ACTIVITY: 'New Activity',
	DETAILS_HEADER_BUTTON_NEW_WORKREPORT: 'New Workreport',
	DETAILS_HEADER_BUTTON_NEW_TICKET: 'New Ticket',
	DETAILS_HEADER_BUTTON_NEW_INVOICE: 'New Invoice',
	// DETAILS_HEADER_BUTTON_NEW_CALL: 'New Call',
	// DETAILS_HEADER_BUTTON_NEW_NOTE: 'New Note',

	DETAILS_HEADER_BUTTON_ADD_TO_COMMERCIALCAMPAIGN: 'Add to Commercial Campaign',
	DETAILS_HEADER_BUTTON_ADD_TO_MARKETINGACTION: 'Add to Marketing Action',
	DETAILS_HEADER_BUTTON_ADD_TO_DEM: 'Add to DEM',

	DETAILS_TABS_CHILDREN: 'Subsidiary',
	DETAILS_TABS_LEAD_COMPANIES: 'Lead Companies',
	DETAILS_TABS_LEAD_PERSON: 'Lead People',
	// DETAILS_TABS_RECIPIENTS: 'Recipients',
	// DETAILS_TAB_WBS: 'WBS',
	DETAILS_TAB_GANTT: 'Activities Planner',
	// #endregion

	// #region Contacts
	CONTACTS_LINKED_TABLE: 'Linked table',
	// #endregion

	// #region Tags
	DETAILS_TAGS_FIELD_ID: 'Code',
	DETAILS_TAGS_FIELD_TITLE: 'Title',
	DETAILS_TAGS_FIELD_USER_CREATED: 'Created by',
	DETAILS_TAGS_FIELD_DATE_CREATED: 'Creation date',
	TAGS_ADD: 'Add',
	// #endregion

	// #region ALERT
	ALERT_UPDATING: 'Updating...',
	ALERT_ADD_SUCCESS: 'New record added successfully!',
	ALERT_UPDATE_SUCCESS: 'Record updated successfully!',
	ALERT_DELETE_SUCCESS: 'Record deleted successfully!',
	ALERT_RESTORE_SUCCESS: 'Record restored successfully!',
	ALERT_DATA_MISSING_DATA: 'Missing data!',
	ALERT_MSG_SUCCESS: 'Operation Successful!',
	// #endregion

	// #region DIALOGS
	DIALOG_TITLE_FILTER: 'Set filter',
	DIALOG_TITLE_FILTER_DETAILS: 'Filter Details',
	DIALOG_TITLE_FILTER_SAVE: 'Save filter',
	DIALOG_TITLE_FILTER_LOAD: 'Load filter',
	DIALOG_TITLE_QUERY_BUILDER: 'Advanced filter',
	DIALOG_TITLE_DATERANGE: 'Start Date 🠒 End Date',
	DIALOG_TITLE_ADD: 'Add {module}',
	DIALOG_TITLE_UPDATE: 'Edit {module}',
	DIALOG_TITLE_DELETE: 'Are you sure you want to delete "{title}"?',
	DIALOG_TITLE_DELETE_GENERIC: 'Are you sure you want to delete this element?',
	DIALOG_TITLE_DELETE_MULTIPLE: 'Are you sure you want to delete the selected elements?',
	DIALOG_TITLE_RESTORE: 'Are you sure you want to restore "{title}"?',
	DIALOG_EMPTY_LIST: 'Are you sure you want to empty this list?',
	DIALOG_TITLE_NOTES_ADD: 'Add Note',
	DIALOG_TITLE_NOTES_EDIT: 'Edit Note',
	DIALOG_TITLE_ITEMS_ADD: 'Add Item',
	DIALOG_TITLE_ITEMS_EDIT: 'Edit Item',
	DIALOG_TITLE_REPORTING: 'Generate Report',
	DIALOG_TITLE_SHOW_FIELD_LOG: 'Log field "{field}"',
	DIALOG_TITLE_RESET_PASSWORD: 'Reset Password',

	DIALOG_USER_PASSWORD_OLD: 'Old password',
	DIALOG_USER_PASSWORD_NEW: 'New password',
	DIALOG_USER_PASSWORD_CONFIRM_NEW: 'Confirm new password',

	DIALOG_TITLE_SHARE: 'Share',
	DIALOG_COPIED_ALERT: 'Copied to clipboard!',

	DIALOG_ACTION_CLOSE: 'Close',
	DIALOG_ACTION_BACK: 'Back',
	DIALOG_ACTION_CANCEL: 'Cancel',
	DIALOG_ACTION_CLEAR: 'Clear',
	DIALOG_ACTION_NEXT: 'Next',
	DIALOG_ACTION_SAVE: 'Save',
	DIALOG_ACTION_ADD: 'Add',
	DIALOG_ACTION_APPLY: 'Apply',
	DIALOG_ACTION_CONFIRM: 'Confirm',
	DIALOG_ACTION_OPEN: 'Open',
	DIALOG_ACTION_SAVE_FILTER: 'Save filter',
	DIALOG_ACTION_LOAD_FILTER: 'Load filter',
	DIALOG_ACTION_OPEN_FULL_DETAILS: 'Open full details',
	// DIALOG_ACTION_DATE_TODAY: 'Today',

	DIALOG_FILTER_NAME: 'Filter name',
	DIALOG_FILTER_PUBLIC: 'Public filter',

	DIALOG_COMPANIES_RELATIONS_TYPE: 'Company Relation Type',
	DIALOG_COMPANIES_RELATIONS_TYPE_CUSTOMERS: 'Customers',
	DIALOG_COMPANIES_RELATIONS_TYPE_SUPPLIERS: 'Suppliers',
	DIALOG_COMPANIES_RELATIONS_TYPE_OTHERS: 'Others',
	DIALOG_COMPANIES_TYPES_ID: 'Company Type',
	DIALOG_ATECO_CODE: 'ATECO Code',
	DIALOG_ATECO_TITLE: 'Title',
	DIALOG_ATECO_TYPES_ID: 'Type',
	DIALOG_ATECO_TYPES_TITLE: 'Title',

	DIALOG_LEGAL_FORM_CODE: 'Code',
	DIALOG_LEGAL_FORM_TITLE: 'Legal form',

	DIALOG_DISTRICTS_TITLE: 'District name',
	DIALOG_DISTRICTS_ISO: 'Initials',
	DIALOG_DISTRICTS_REGION: 'Region',
	DIALOG_REGIONS_TITLE: 'Region name',
	DIALOG_REGIONS_ISO: 'ISO Code',
	DIALOG_REGIONS_COUNTRY: 'Country',
	DIALOG_COUNTRIES_TITLE: 'Country name',
	DIALOG_COUNTRIES_ISO: 'ISO Code',
	DIALOG_COUNTRIES_GROUP: 'Country Group',
	DIALOG_COUNTRIES_GROUP_CEE: 'CEE',
	DIALOG_COUNTRIES_GROUP_EXTRA_CEE: 'Extra CEE',

	DIALOG_SOCIAL_NETWORK_TYPES_ICON: 'Icon',

	DIALOG_INVOICES_TYPES_GROUP: 'Invoice Type Group',
	DIALOG_INVOICES_TYPES_GROUP_INCOMES: 'Incomes',
	DIALOG_INVOICES_TYPES_GROUP_EXPENSES: 'Expenses',
	DIALOG_INVOICES_TYPES_CREDITNOTE: 'Credit note',

	DIALOG_PROJECTS_TYPES_WBSMODEL: 'WBS Model',

	DIALOG_REPLACE_NULL: 'Replace with an empty value',
	DIALOG_REPLACE: 'Replace with',

	// DIALOG_REFRESH_COORDINATES: 'Refresh coordinates',
	// DIALOG_SEARCH_COORDINATES: 'Search coordinates',

	// DIALOG_MAILS_TITLE: 'Mail Address',
	// DIALOG_PHONES_TITLE: 'Phone Number',
	// DIALOG_SOCIALNETWORKS_TITLE: 'Social Network',

	DIALOG_TITLE_ADD_TO: 'Add to',

	DIALOG_LOGO_TITLE: 'Change avatar',
	DIALOG_LOGO_UPLOAD: 'Upload',
	DIALOG_LOGO_UPLOAD_DESCRIPTION: 'Pick an image from your device and upload it',
	DIALOG_LOGO_FIND: 'Web Search',
	DIALOG_LOGO_FIND_DESCRIPTION: "Show a small set of images from Internet based on the company's title",

	DIALOG_IMAGE_EDITOR: 'Image Editor',
	IMAGE_RESIZER_WIDTH: 'Width',
	IMAGE_RESIZER_HEIGHT: 'Height',
	// DIALOG_COORDINATES_DESCRIPTION:
	// 	"Search for or refresh the coordinates of this address, keep in mind that you will consume one of the 250k monthly calls you have by pressing 'Confirm'",

	// DIALOG_UPLOAD_BUSNINESS_CARD_TITLE: 'Upload Business Card Images',
	// #endregion

	// #region COMMON
	// YES: 'Yes',
	// NO: 'No',
	DIVIDER_OR: 'OR',
	// #endregion

	// #region HTML Editor
	HTMLEDITOR_BOLD: 'Bold',
	HTMLEDITOR_ITALIC: 'Italic',
	HTMLEDITOR_UNDERLINE: 'Underline',
	HTMLEDITOR_STRIKETHROUGH: 'Strike Through',
	HTMLEDITOR_H1: 'Header 1',
	HTMLEDITOR_H2: 'Header 2',
	HTMLEDITOR_H3: 'Header 3',
	HTMLEDITOR_P: 'Paragraph',
	HTMLEDITOR_NUMBEREDLIST: 'Numbered List',
	HTMLEDITOR_BULLETEDLIST: 'Bulleted List',
	HTMLEDITOR_ADDLINK: 'Add Link',
	HTMLEDITOR_START_STT: 'Start listening',
	HTMLEDITOR_STOP_STT: 'Stop listening',
	HTMLEDITOR_UNDO: 'Undo',
	HTMLEDITOR_REDO: 'Redo',
	// #endregion

	// #region Prompt texts
	PROMPT_TEXT_UNSAVED: 'There are unsaved changes. Are you sure you want to exit?',
	// #endregion

	// #region File viewer
	FILE_EXPLORER_UPLOAD_FILE: 'Upload file',
	FILE_EXPLORER_COLUMN_NAME: 'Name',
	FILE_EXPLORER_COLUMN_TYPE: 'Type',
	FILE_EXPLORER_COLUMN_LAST_MODIFIED: 'Last modified',
	FILE_EXPLORER_COLUMN_SIZE: 'Size',
	FILE_EXPLORER_EMPTY_FOLDER: 'The folder is empty.',
	FILE_EXPLORER_FILE_DIALOG_SUBTITLE: 'Size: {size} - Last modified : {date}',
	FILE_VIEWER_NOT_SUPPORTED: 'File format {fileType} preview is not supported.',
	// #endregion

	// #region Mail Viewer
	MAIL_INBOUND: 'Received',
	MAIL_OUTBOUND: 'Sent',
	MAIL_SUBJECT: 'Subject',
	MAIL_FROM: 'From',
	MAIL_TO: 'To',
	MAIL_DATE_SENT: 'Send date',
	MAIL_DATE_RECEIVED: 'Received date',
	// #endregion

	// #region Validation messages
	ERROR_TEXT_REQUIRED: 'Required field',
	ERROR_TEXT_MAXLENGTH: 'The maximum length allowed by the field has been exceeded',
	ERROR_TEXT_PHONE: 'Invalid phone number',
	ERROR_TEXT_EMAIL: 'Invalid mail',
	ERROR_MIN_VALUE: 'Il valore non può essere minore di {{value}}',
	ERROR_MAX_VALUE: 'Il valore non può essere maggiore di {{value}}',
	ERROR_MIN_CURRENCY: 'Il valore non può essere minore di {{value, currency}}',
	ERROR_MAX_CURRENCY: 'Il valore non può essere maggiore di {{value, currency}}',
	ERROR_MIN_DATE: 'The date cannot be before {value}',
	ERROR_MAX_DATE: 'The date cannot be after {value}',
	ERROR_MIN_TIME: 'The time cannot be before {value}',
	ERROR_MAX_TIME: 'The time cannot be after {value}',
	ERROR_NUMBER_ONLY_INT: 'Decimal values are not allowed',
	ERROR_TEXT_NO_DUPLICATED_CAMPAIGNS:
		'Fields "Origin Mareting Action" and "Commercial Campaign Action" cannot be both compiled',
	// ERROR_TEXT_TIME: 'Invalid time format',
	ERROR_IMAGE_NOT_AVAILABLE: 'Image not available.',
	ERROR_FILE_READ: 'Error while loading file.',
	ERROR_FILE_VIDEO_NOT_SUPPORTED: 'Video playback is not supported by your browser.',
	ERROR_FILE_AUDIO_NOT_SUPPORTED: 'Audio playback is not supported by your browser.',
	// ERROR_VALUE_TOO_HIGH: 'The value is too high.',
	// ERROR_VALUE_TOO_LOW: 'The value is too low.',
	// ERROR_DATE_TOO_LATE: 'The date is too late.',
	// ERROR_DATE_TOO_EARLY: 'The date is too early.',
	ERROR_PASSWORD_NO_MATCH: "Password fields doesn't match",
	ERROR_WRONG_USER_OR_PASSWORD: 'Wrong user or password',
	ERROR_NEW_PASSWORD_MATCH_OLD: 'New password cannot be the same as old password',
	ERROR_FILTER_SAVE_EMPTY: 'You must set at least one filter to be able to save it',
	// #endregion

	// #region Details Notes section
	NOTES_SECTION: 'Notes',
	NOTES_SUBHEADER: 'View and edit notes',
	// #endregion

	// #region Reporting components
	REPORTING_STEP_TEMPLATE: 'Select template',
	REPORTING_STEP_PARAMETERS: 'Edit parameters',
	REPORTING_STEP_RESULT: 'View result',
	REPORTING_FIELD_FILENAME: 'File Name',
	REPORTING_FIELD_FILEFORMAT: 'Export Format',
	REPORTING_BUTTON_VIEW: 'View',
	REPORTING_BUTTON_DOWNLOAD: 'Download',
	// #endregion

	// #region Documents settings dialog
	DETAILS_HEADER_BUTTON_DOCUMENTS_SETTINGS: 'Docs configuration',
	DOCUMENTS_SETTINGS_DIALOG_TITLE: 'Docs configuration',
	DOCUMENTS_SETTINGS_DIALOG_CURRENTPATH: 'Current path',
	DOCUMENTS_SETTINGS_DIALOG_DESCRIPTION1:
		'Use the "Folder Name" field to change the folder where documents are saved.',
	DOCUMENTS_SETTINGS_DIALOG_DESCRIPTION2:
		'ATTENTION: the existing documents will remain in the previous folder and will have to be moved by hand to the new path.',
	DOCUMENTS_SETTINGS_DIALOG_FIELD_FOLDERNAME: 'Folder name',
	// #endregion

	// #region Date range filter
	DATERANGE_FILTER_PRESET: 'Range',

	DATERANGE_PRESET_CUSTOM: 'Custom',
	DATERANGE_PRESET_LASTSEVENDAYS: 'Last 7 days',
	DATERANGE_PRESET_NEXTSEVENDAYS: 'Next 7 days',
	DATERANGE_PRESET_LASTWEEK: 'Last week',
	DATERANGE_PRESET_CURRENTWEEK: 'Current week',
	DATERANGE_PRESET_NEXTWEEK: 'Next week',
	DATERANGE_PRESET_LASTMONTH: 'Last month',
	DATERANGE_PRESET_CURRENTMONTH: 'Current month',
	DATERANGE_PRESET_NEXTMONTH: 'Next month',
	DATERANGE_PRESET_LASTYEAR: 'Last year',
	DATERANGE_PRESET_CURRENTYEAR: 'Current year',
	DATERANGE_PRESET_NEXTYEAR: 'Next year',
	// #endregion

	// #region WBS
	WBS_DURATION: 'Duration: {value} hours',

	WBS_SECTION_NEW_TITLE: 'Work Breakdown Structure (WBS)',
	WBS_SECTION_NEW_SUBHEADER: 'Click the "New" button on the right to associate a WBS Graph to this element',

	WBS_TITLE: 'WBS Editor',
	WBS_HELPTEXT:
		'Select a node to see its details and be able to edit it. You can expand or collapse a branch using the small arrow to the left of the name or add a node by pressing the "+" key.',
	WBS_HELPTEXT_WARNING:
		'WARNING: it is not possible to add nodes to a leaf or transform a branch containing other nodes into a leaf.',

	WBS_NEW_NODE_TITLE: 'New node',
	WBS_ADD_NODE_BUTTON: 'Add node',

	WBS_NODES_FIELD_TITLE: 'Title',
	WBS_NODES_FIELD_DESCRIPTION: 'Description',
	WBS_NODES_FIELD_TYPE: 'Node type',
	WBS_NODES_FIELD_TYPE_BRANCH: 'Branch',
	WBS_NODES_FIELD_TYPE_LEAF: 'Leaf',
	WBS_NODES_FIELD_ORDER: 'Order',
	WBS_NODES_FIELD_ACTIVITY_TYPE: 'Activity Type',
	WBS_NODES_FIELD_DATE_FROM_EXPECTED: 'Expected start date',
	WBS_NODES_FIELD_DATE_TO_EXPECTED: 'Expected end date',
	WBS_NODES_FIELD_INHERIT_USER_ASSIGNED: 'Inherit user assigned from parent',
	WBS_NODES_FIELD_USER_ASSIGNED: 'User assigned',
	WBS_NODES_FIELD_HOURS_EXPECTED: 'Expected hours',

	DETAILS_WBS_MODELS_FIELD_TITLE: 'Title',
	DETAILS_WBS_MODELS_FIELD_DESCRIPTION: 'Description',
	DETAILS_WBS_MODELS_FIELD_WARNING: 'Warning',
	DETAILS_WBS_MODELS_FIELD_BLOCKED: 'Blocked',

	WBS_DIALOG_ACTION_SAVE_MODEL: 'Save model',
	WBS_DIALOG_ACTION_LOAD_MODEL: 'Load model',
	WBS_DIALOG_ACTION_GENERATE_ACTIVITIES: 'Generate Activities',
	// #endregion

	// #region Lines
	TOT_VALUE_TAX_EXCLUDED: 'Total price (tax excluded): {value}',
	TOT_VALUE_TAX_INCLUDED: 'Total price (tax included): {value}',
	TOT_VALUE_TAX_EXCLUDED_PROMOS_DISCOUNT: 'Total price (tax excluded) including extradiscount: {value}',
	TOT_EXPENSES: 'Total expenses: {value}',
	TOT_MERCH_POINTS: 'Total Merch Points: {value}',
	LINES_ISGIFT: 'Gift',
	// #endregion

	// #region Postpone dialog
	VIEW_ITEM_BUTTON_POSTPONE: 'Postpone',
	DIALOG_TITLE_POSTPONE: 'Are you sure you want to push the end date back by 10 days?',
	// #endregion

	// #region Document templates dialog
	VIEW_ITEM_BUTTON_GENERATE_DOCUMENT: 'Generate document',

	DOCUMENT_TEMPLATES_FIELD_TITLE: 'Template name',
	DOCUMENT_TEMPLATES_FIELD_DESCRIPTION: 'Template description',
	DOCUMENT_TEMPLATES_FIELD_MODULE: 'Module',
	DOCUMENT_TEMPLATES_FIELD_FILENAME_TEMPLATE: 'Document filename',
	DOCUMENT_TEMPLATES_FIELD_VIEWNAME: 'DB view name',
	DOCUMENT_TEMPLATES_FIELD_FORMAT: 'File format',

	DIALOG_DOCUMENT_TEMPLATES_TITLE: 'Document templates',
	DIALOG_DOCUMENT_TEMPLATES_EDIT_TITLE: 'Edit Carbone model',
	DIALOG_CLOSING_DAYS_EDIT_TITLE: 'Edit Closing Day',
	DIALOG_CLOSING_DAYS_NEW_TITLE: 'Add Closing Day',
	DIALOG_DOCUMENT_TEMPLATES_UPLOAD: 'Upload',
	DIALOG_TEMPLATES_UPLOAD_DRAG_AND_DROP: 'Drag and drop a file to upload',
	DIALOG_TEMPLATES_UPLOAD_AVAILABILITY: 'Your template will be available to all users',
	DIALOG_TEMPLATES_UPLOAD_OR: 'or',
	DIALOG_TEMPLATES_UPLOAD_SELECT_FILE_BUTTON: 'Select file',
	DIALOG_TEMPLATES_UPLOAD_DROP_AREA: 'Release Here',
	DIALOG_TEMPLATES_UPLOAD_FILENAME: 'Uploaded file',
	DIALOG_TEMPLATES_EXPORTED_SCHEDULED_TITLE: 'Your template has been scheduled for exporting.',
	DIALOG_TEMPLATES_EXPORTED_SCHEDULED_DESCRIPTION: 'Check your notifications to download it when it will be ready.',
	// #endregion

	// #region Importables dialog
	IMPORTABLES_DIALOG_IMPORT_TITLE: 'Import from Excel file',
	IMPORTABLES_DIALOG_IMPORT_STEP_TEMPLATE: 'Choose the template',
	IMPORTABLES_DIALOG_IMPORT_STEP_UPLOAD: 'Choose the file',
	IMPORTABLES_DIALOG_IMPORT_STEP_IMPORT: 'Upload the file'
	// #endregion
};

export default locale;
